import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import auth from './modules/auth';
import alerts from './modules/alerts';
import preloader from './modules/preloader';
import data from './modules/data';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'dev-portal',
      reducer(state) {
        return {
          alerts: state.alerts,
          auth: state.auth,
          preloader: state.preloader,
        };
      },
    }),
  ],
  modules: {
    auth,
    alerts,
    preloader,
    data,
  },
});

export default store;
